// Share the same network boundary across the SDK and page requests.
export function mainnetFetch(transport: typeof fetch, legacy = false): typeof fetch {
  let checkedUntil = 0;
  let checking: Promise<void> | undefined;
  const verify = async () => {
    const response = await transport('/api/config', {credentials: 'include', cache: 'no-store'});
    if (!response.ok) throw new Error('Mainnet connection unavailable. Please retry.');
    const config = await response.json();
    if (config.mode !== 'production' || config.chainId !== 56 || config.localFixture !== false || config.hostedPreview || (config.legacyDeployment === true) !== legacy)
      throw new Error('Mainnet connection unavailable. Please retry.');
    checkedUntil = Date.now() + 15_000;
  };
  const hasFixture = (value: unknown): boolean => {
    if (!value || typeof value !== 'object') return false;
    const item = value as Record<string, unknown>;
    return item.localFixture === true || item.fixture === true || item.hostedPreview === true || item.status === 'local-fixture' || Object.values(item).some(hasFixture);
  };
  return async (input, init) => {
    if (Date.now() >= checkedUntil) {
      checking ??= verify().finally(() => { checking = undefined; });
      await checking;
    }
    const response = await transport(input, init);
    if (response.ok && response.headers.get('content-type')?.includes('application/json')) {
      const data = await response.clone().json();
      if (hasFixture(data) || (data?.chainId !== undefined && data?.mode !== undefined && (data.chainId !== 56 || data.mode !== 'production'))) {
        checkedUntil = 0;
        throw new Error('Mainnet data unavailable. Please retry.');
      }
    }
    return response;
  };
}
